<div>
  <div class="paragraph">
    <p class="paragraph_title">
      {{ 'MyProfile_AS_SecurityQuestion' | translate }}
    </p>
    <p class="paragraph_instruction">
      {{ 'MyProfile_AS_SecurityText' | translate }}
    </p>
  </div>
  <div class="qna_control">
    <div class="form-group qna_control_question">
      <label>{{ 'MyProfile_AS_ChallengeQuestion' | translate }}</label>
      <select class="form-control" [(ngModel)]="qna.question">
        <option *ngFor="let question of questions" [value]="question.value">{{ question.text }}</option>
      </select>
    </div>
    <div>
      <form [formGroup]="formGroup">
        <div class="form-group qna_control_answer">
          <label for="answer">{{ 'MyProfile_AS_ChallengeAnswer' | translate }}</label>
          <input id="answer" formControlName="answer" type="text" class="form-control" />
        </div>
      </form>
    </div>
  </div>
</div>
